import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import {
  CREATE_CUSTOMFIELD_START,
  GETCUST_CUSTOMFIELD_START,
  GETLEADS_CUSTOMFIELD_START,
  UPDATE_CUSTOMFIELD_START,
} from "./ActionTypes"

import {
  createCustomFieldSuccess,
  createCustomFieldError,
  getLeadsCustomFieldSuccess,
  getLeadsCustomFieldError,
  updateCustomFieldSuccess,
  updateCustomFieldError,
  getCustomerCustomFieldSuccess,
  getCustomerCustomFieldError,
} from "./Action"
import {
  createCustomFieldApi,
  getLeadsCustomFieldApi,
  updateCustomFieldApi,
  getCustomerCustomFieldApi,
} from "./Api"

function* createCustomFieldAsync(action) {
  try {
    const response = yield call(createCustomFieldApi, action.payload)
    if (response.status === 200 || 201) {
      yield put(createCustomFieldSuccess(response.data))
    } else {
      yield put(
        createCustomFieldError(response.data.message)
      )
    }
  } catch (error) {
    yield put(
      createCustomFieldError(error.response.data.message)
    )
  }
}
function* createCustomField() {
  yield takeEvery(CREATE_CUSTOMFIELD_START, createCustomFieldAsync)
}

function* getLeadsCustomFieldAsync(action) {
  try {
    const response = yield call(getLeadsCustomFieldApi)
    if (response.status === 200 || 201) {
      yield put(getLeadsCustomFieldSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(
      getLeadsCustomFieldError("Something Error occured... please try again")
    )
  }
}
function* getLeadsCustomField() {
  yield takeEvery(GETLEADS_CUSTOMFIELD_START, getLeadsCustomFieldAsync)
}

function* updateCustomFieldAsync(action) {
  try {
    console.log("sdfds")
    const response = yield call(updateCustomFieldApi, action.payload)
    if (response.status === 200 || 201) {
      yield put(updateCustomFieldSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(
      updateCustomFieldError("Something Error occured... please try again")
    )
  }
}
function* updateCustomField() {
  yield takeEvery(UPDATE_CUSTOMFIELD_START, updateCustomFieldAsync)
}

function* getCustomerCustomFieldAsync(action) {
  try {
    const response = yield call(getCustomerCustomFieldApi)
    if (response.status === 200 || 201) {
      yield put(getCustomerCustomFieldSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(
      getCustomerCustomFieldError("Something Error occured... please try again")
    )
  }
}
function* getCustomerCustomField() {
  yield takeEvery(GETCUST_CUSTOMFIELD_START, getCustomerCustomFieldAsync)
}

function* CustomFieldSaga() {
  yield all([
    fork(createCustomField),
    fork(getLeadsCustomField),
    fork(updateCustomField),
    fork(getCustomerCustomField),
  ])
}
export default CustomFieldSaga
